import api from './api';

let cache = null;
let inflight = null;

export const publicSettings = {
  get: async () => {
    if (cache) return cache;
    if (inflight) return inflight;
    inflight = api.get('/settings/public').then((r) => { cache = r.data; inflight = null; return cache; })
      .catch(() => { inflight = null; return {}; });
    return inflight;
  },
  reset: () => { cache = null; },
};
